export default __webpack_public_path__ + "static/media/AdDinosaurs_07.418bba49.png";